var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-layout',{attrs:{"row":"","justify-space-between":"","id":"home-footer"}},[_c('active-workspace'),_vm._v(" "),_c('active-action'),_vm._v(" "),_c('active-tool'),_vm._v(" "),_c('projection'),_vm._v(" "),_c('coordinates'),_vm._v(" "),_c('scale'),_vm._v(" "),_c('current-client')],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-55cc80c8","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Home/Footer/Footer.vue
// module id = null
// module chunks = 